import modalStyles from '../../../components/modal/modal.module.scss';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../../support/use_click_outside.ts';
import {OccasionType} from '../../../gql/pwa/graphql.ts';
import {classNames} from '../../../support/classnames.ts';
import {OccasionSlider} from '../../../components/occasion_slider.tsx';

interface OwnProps {
    onCloseModal: () => void;
    occasion?: OccasionType | null;
    start?: number;
}
export function OccasionsModal({onCloseModal, occasion, start}: OwnProps) {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const ref = React.useRef<HTMLDivElement | null>(null);

    const closeModalCallback = useCallback(() => {
        onCloseModal();
    }, []);
    useClickOutside(ref, closeModalCallback);

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={classNames(modalStyles.modal, modalStyles.full)}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        <h2>
                            {occasion?.brand} {occasion?.model}
                        </h2>
                        <button disabled={isLoading} type="button" onClick={() => onCloseModal()}>
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <div className={modalStyles.occasion_modal__slider}>
                            {occasion?.pictures && occasion.pictures?.length > 0 && (
                                <OccasionSlider start={start} infinite={false} className={'occasion-details-slider'}>
                                    {occasion.pictures.slice(0, occasion.pictures.length - 1).map((pic) => (
                                        <div key={pic}>
                                            <img src={pic!} alt={occasion?.model ?? ''} />
                                        </div>
                                    ))}
                                </OccasionSlider>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
